export enum BrandFormType {
  BrandRegister = 'brand-register',
}
